import React from 'react'
import Navbar from '../components/Navbar'
import Dashboard from '../components/Dashboard'

const Index = () => {
  return (
    <div>
        <Navbar/>
        <Dashboard/>
    </div>
  )
}

export default Index